import React from "react";

const CaseStudyCard = ({ item }) => (
  <div className="col-lg-4 col-md-6">
    <article className="cs-card">
      <p className="cs-meta">{item.year}</p>
      <h3>{item.title}</h3>
      <p className="cs-role">{item.role}</p>
      <p className="cs-desc">{item.description}</p>
      <ul className="cs-tags">
        {item.tags.map((tag) => (
          <li key={tag}>{tag}</li>
        ))}
      </ul>
      <a
        className="primary-btn text-uppercase align-self-start"
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Read the ${item.title} case study on tabrezdal.com (opens in a new tab)`}
      >
        Read the case study
      </a>
    </article>
  </div>
);

export default CaseStudyCard;
